module.exports = __webpack_public_path__ + "static/media/longSandwich.48d2b0b9.png";